import React, { useState, useEffect } from "react";
import { Modal, ModalFooter, ModalHeader, ModalBody, Button } from "reactstrap";
import Cookies from 'js-cookie';
import moment  from 'moment';

import AdBlockImg from "~/assets/images/Adblock.png";

const AdBlockerModal = ({})=> {

  const [isModalOpen, setModalOpen] = useState(false);

  useEffect(()=> {
    if((!(document.getElementById("adframe").clientHeight > 0)) && !Cookies.get("AdBlock")) setModalOpen(true);
  }, []);

  const toggleModal= ()=> setModalOpen(!isModalOpen);

  const close = ()=> {
    const expiration = moment().add(7, "days").toDate();
    Cookies.set('AdBlock', true, {expires: expiration});
    setModalOpen(false);
  };

  return (
    <div>
      <div id="adframe" style={{height: 1}} > </div>

      <Modal isOpen={isModalOpen} toggle={toggleModal} centered>
        <ModalHeader toggle={toggleModal}> AdBlock Detected! </ModalHeader>

        <ModalBody>
          <div className="f-16 text-center">
            <img src={AdBlockImg} style={{ height: 150, width: 150}} />
            <p className="m-t-20 m-b-0">We have detected that you are using AdBlock.<br></br> For a better user experience and more offers please deactivate it.</p>
          </div>
        </ModalBody>

        <ModalFooter className="justify-content-center">
          <Button color="info" onClick={close}> Confirm </Button>
        </ModalFooter>
      </Modal>
    </div>
  );

};

export default AdBlockerModal;

